import React, { useState } from 'react';
import useApi from '../../helpers/TerserahApi';
import Cookies from 'js-cookie';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  SaveButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Input,
  CheckboxContainer,
  ButtonGroup,
  SubmitButton,
  CancelButton
} from './style';

const SaveSearch = () => {
  const api = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [searchName, setSearchName] = useState('');
  const [notifyNewAds, setNotifyNewAds] = useState(true);
  const [saving, setSaving] = useState(false);

  const isLoggedIn = () => !!Cookies.get('token');

  const getCurrentSearchParams = () => {
    const params = new URLSearchParams(location.search);
    const searchParams = {};
    
    if (params.get('q')) searchParams.q = params.get('q');
    if (params.get('state')) searchParams.state = params.get('state');
    if (params.get('cat')) searchParams.category = params.get('cat');
    if (params.get('minPrice')) searchParams.minPrice = params.get('minPrice');
    if (params.get('maxPrice')) searchParams.maxPrice = params.get('maxPrice');

    return searchParams;
  };

  const getDefaultName = () => {
    const params = getCurrentSearchParams();
    const parts = [];
    
    if (params.q) parts.push(params.q);
    if (params.category) parts.push(params.category);
    if (params.state) parts.push(params.state);
    
    return parts.length > 0 ? parts.join(' - ') : 'Mi búsqueda';
  };

  const handleSave = async () => {
    if (!isLoggedIn()) {
      alert('Debes iniciar sesión para guardar búsquedas');
      navigate('/signin');
      return;
    }

    const params = getCurrentSearchParams();
    
    if (Object.keys(params).length === 0) {
      alert('No hay parámetros de búsqueda para guardar');
      return;
    }

    if (!searchName.trim()) {
      alert('Por favor ingresa un nombre para la búsqueda');
      return;
    }

    setSaving(true);
    try {
      const json = await api.createSavedSearch(searchName.trim(), params, notifyNewAds);
      if (json.success) {
        alert('Búsqueda guardada exitosamente');
        setShowModal(false);
        setSearchName('');
      } else {
        alert(json.error || 'Error al guardar búsqueda');
      }
    } catch (err) {
      alert('Error al guardar búsqueda');
    }
    setSaving(false);
  };

  return (
    <>
      <SaveButton onClick={() => {
        if (!isLoggedIn()) {
          alert('Debes iniciar sesión para guardar búsquedas');
          navigate('/signin');
        } else {
          setSearchName(getDefaultName());
          setShowModal(true);
        }
      }}>
        🔖 Guardar búsqueda
      </SaveButton>

      {showModal && (
        <Modal>
          <ModalOverlay onClick={() => setShowModal(false)} />
          <ModalContent>
            <ModalHeader>
              <h3>Guardar búsqueda</h3>
              <p>Recibe notificaciones cuando haya nuevos anuncios que coincidan</p>
            </ModalHeader>

            <div style={{ padding: '25px' }}>
              <label>Nombre de la búsqueda</label>
              <Input
                type="text"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                placeholder="Ej: Casas en Madrid"
                maxLength={100}
              />

              <CheckboxContainer>
                <input
                  type="checkbox"
                  id="notify"
                  checked={notifyNewAds}
                  onChange={(e) => setNotifyNewAds(e.target.checked)}
                />
                <label htmlFor="notify">
                  Notificarme cuando haya nuevos anuncios
                </label>
              </CheckboxContainer>

              <ButtonGroup>
                <CancelButton onClick={() => {
                  setShowModal(false);
                  setSearchName('');
                }}>
                  Cancelar
                </CancelButton>
                <SubmitButton onClick={handleSave} disabled={saving || !searchName.trim()}>
                  {saving ? 'Guardando...' : 'Guardar Búsqueda'}
                </SubmitButton>
              </ButtonGroup>
            </div>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default SaveSearch;
